import { clsx, type ClassValue } from "clsx";
import { motion } from "motion/react";
import type { ReactNode } from "react";
import { BsArrowRight } from "react-icons/bs";

const CircleIconAnimationButton = ({
  children = "Show More",
  className,
  icon = <BsArrowRight size={18} />,
  type = "button",
}: {
  children?: ReactNode;
  icon?: ReactNode;
  className?: ClassValue[] | ClassValue;
  type?: "button" | "submit" | "reset";
}) => {
  return (
    <motion.div
      initial="initial"
      whileHover="hover"
      transition={{
        duration: 0.3,
        ease: "easeIn",
      }}
      className={clsx(
        "flex cursor-pointer justify-center items-center",
        className,
      )}
    >
      <motion.button
        type={type}
        variants={{
          initial: {
            color: "#e0e0e0",
          },
          hover: {
            color: "#111212",
          },
        }}
        className="cursor-pointer font-semibold text-xl inline-flex relative items-center justify-between rounded-full overflow-hidden px-3 gap-5 py-3 border border-white/10 bg-[#4c94ba]"
      >
        <span className="px-3 relative z-2">{children}</span>
        <motion.span
          variants={{
            initial: {
              backgroundColor: "#111212",
              width: "500px",
              right: "-20px",
            },
            hover: {
              backgroundColor: "#111212",
              width: "28px",
              right: "12px",
            },
          }}
          transition={{
            duration: 0.4,
            ease: [0.19, 1, 0.22, 1],
          }}
          className="z-1 absolute top-1/2 -translate-y-1/2 aspect-square rounded-full flex items-center justify-center pointer-events-none"
        ></motion.span>
        <motion.div
          variants={{
            initial: {
              color: "#e0e0e0",
            },
            hover: {
              color: "#e0e0e0",
            },
          }}
          className="w-7 overflow-hidden flex items-center justify-start relative z-2"
        >
          <motion.div
            variants={{
              initial: {
                x: "0px",
              },
              hover: {
                x: "-36px",
              },
            }}
            transition={{
              duration: 0.3,
              ease: "easeIn",
            }}
            className="min-w-fit flex flex-nowrap gap-[8px]"
          >
            <span className="w-7 flex items-center justify-center">{icon}</span>
            <span className="w-7 flex items-center justify-center">{icon}</span>
          </motion.div>
        </motion.div>
      </motion.button>
    </motion.div>
  );
};

export default CircleIconAnimationButton;
